// AUTO-GENERATED GraphQL Builder for PaymentOrderResult
import * as Builders from '../';
export class PaymentOrderResultBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  paymentId(){ return this.add('paymentId'); }
  orderId(){ return this.add('orderId'); }
  keyId(){ return this.add('keyId'); }
  amount(){ return this.add('amount'); }
  currency(){ return this.add('currency'); }
  prefillName(){ return this.add('prefillName'); }
  prefillEmail(){ return this.add('prefillEmail'); }
  prefillContact(){ return this.add('prefillContact'); }
}
